import {Component, Input, ChangeDetectionStrategy} from '@angular/core';
import {GENDERS_WITH_TRANSLATE_KEYS, Sex} from "../../../../../shared/user";
import {FormControl, ReactiveFormsModule} from "@angular/forms";
import {MatIconModule, MatIconRegistry} from "@angular/material/icon";
import {DomSanitizer} from "@angular/platform-browser";
import { NgClass } from "@angular/common";
import {MatInputModule} from "@angular/material/input";
import {MatSelectModule} from "@angular/material/select";
import {TranslateDirective, TranslatePipe, TranslateService} from "@ngx-translate/core";
import {LANGUAGE_RU} from "../../../../../shared/language";

@Component({
    selector: 'app-gender-select',
    templateUrl: './gender-select.component.html',
    styleUrls: ['./gender-select.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
    MatIconModule,
    NgClass,
    MatInputModule,
    MatSelectModule,
    ReactiveFormsModule,
    TranslatePipe, TranslateDirective
]
})
export class GenderSelectComponent {

    @Input()
    genderControl: FormControl
    protected availableGenders: Array<{ sex: Sex, translateKey: string }>

    constructor(iconRegistry: MatIconRegistry,
                sanitizer: DomSanitizer,
                translate: TranslateService) {

        if (translate.currentLang() === LANGUAGE_RU) {
            this.availableGenders = GENDERS_WITH_TRANSLATE_KEYS.filter(value => {
                return value.sex != Sex.trans
            })
        } else {
            this.availableGenders = GENDERS_WITH_TRANSLATE_KEYS
        }

        iconRegistry.addSvgIcon(
            'female',
            sanitizer.bypassSecurityTrustResourceUrl('assets/gender-female-v3.svg'));

        iconRegistry.addSvgIcon(
            'male',
            sanitizer.bypassSecurityTrustResourceUrl('assets/gender-male-v3.svg'));

        iconRegistry.addSvgIcon(
            'trans',
            sanitizer.bypassSecurityTrustResourceUrl('assets/gender-male-female-v3.svg'));

    }
}
